var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.inspirationId)?_c('v-btn',_vm._g(_vm._b({class:[
      {
        'disable-events': _vm.isDisabled,
        'rounded-pill elevation-1': _vm.importLabel,
      },
    ],attrs:{"icon":!_vm.importLabel,"x-small":!_vm.large && !_vm.importLabel,"loading":_vm.isLoading},on:{"click":function($event){$event.stopPropagation();return _vm.handleImport.apply(null, arguments)}}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('l-icon',{attrs:{"img":_vm.importIcon,"width":_vm.width,"height":_vm.height}}),_vm._v(" "),(_vm.importLabel)?_c('span',{staticClass:"body-2 ml-2",class:_vm.labelClass},[_vm._v("\n      "+_vm._s(_vm.importLabel)+"\n    ")]):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }